<template>
  <div>
    <hr>
    <a href="javascript:void(0);" @click="pick_video_open = !pick_video_open;" id="pick-video-open" class="h4">Wybierz {{ type == "video" ? "Webinary" : "E-booki" }}</a>
    <div id="pick-video" v-show="pick_video_open">
        <input id="pick-video-search" type="text" class="form-control my-3" v-model="search">
        <div class="row">
            <div class="col-6 col-sm-4 pick-video-option" v-for="video in videos" v-show="search == '' || video.name.includes(search)">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" v-model="video.selected" :id='"video_id_" + video.id' :value='video.id' @change="selectPacket(video)">
                    <label class="form-check-label" :for='"video_id_" + video.id'>{{ video.name }}</label>
                </div>
            </div>
        </div>
    </div>
    <hr>
    Wybrane {{ type == "video" ? "webinary" : "E-booki" }}:
    <table class="table">
      <tr>
        <th>{{ type == "video" ? "Webinar" : "E-book" }}:</th>
        <th>Cena netto:</th>
        <th>Cena netto w pakiecie:</th>
        <th>Cena brutto w pakiecie:</th>
        <th></th>
      </tr>
      <tr v-for="(video, index) in videos_selected">
        <td>
          {{ video.name }}
          <input type="hidden" name="videos[]" :value="video.id">
        </td>
        <td>{{ video.price_net }}</td>
        <td><input type="text" class="form-control" v-model="video.packet_price_net" :name="'price_net[' + video.id + ']'" @change="countPrice(video.id)"></td>
        <td><input type="text" class="form-control" disabled v-model="video.packet_price_gross"></td>
        <td>
          <button class="btn btn-sm btn-info mb-1" type="button" v-if="index != 0" @click="swapUP(video.id)"><i class="fa fa-chevron-up"></i></button>
          <button class="btn btn-sm btn-info" type="button" v-if="index != videos_selected.length - 1" @click="swapDown(video.id)"><i class="fa fa-chevron-down"></i></button>
        </td>
      </tr>
    </table>

    <div class="form-group row align-items-center">
      <label for="total_price_net" class="col-md-4 col-form-label text-md-right">cena netto za cały pakiet</label>
      <div class="col-md-8">
        <input disabled="disabled" name="total_price_net" type="text" v-model="total_price_net" class="form-control">
      </div>
    </div>
    <div class="form-group row align-items-center">
      <label for="total_price_net" class="col-md-4 col-form-label text-md-right">cena brutto za cały pakiet</label>
      <div class="col-md-8">
        <input disabled="disabled" name="total_price_net" type="text" v-model="total_price_gross" class="form-control">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    if (this.type == "video") {
      axios.post('/admin/video-packets/get-videos-list', {video_packet_id: this.video_packet_id}).then(response => {
        this.videos = response.data;
        this.countPrice(0);
      });
      axios.post('/admin/video-packets/get-selected-videos-list', {video_packet_id: this.video_packet_id}).then(response => {
        this.videos_selected = response.data;
      });
    } else if (this.type == "ebook") {
      axios.post('/admin/ebook-packets/get-ebooks-list', {packet_id: this.video_packet_id}).then(response => {
        this.videos = response.data;
        this.countPrice(0);
      });
      axios.post('/admin/ebook-packets/get-selected-ebooks-list', {packet_id: this.video_packet_id}).then(response => {
        this.videos_selected = response.data;
      });
    }
  },
  data: function() {
    return {
      videos: [],
      videos_selected: [],
      pick_video_open: false,
      search: "",
      total_price_net: 0,
      total_price_gross: 0
    }
  },
  props: {
    video_packet_id: false,
    type: false
  },
  methods: {
    countPrice(id) {
      this.total_price_net = 0;
      this.total_price_gross = 0;
      for(var i in this.videos) {
        if (this.videos[i].id == id) {
          this.videos[i].packet_price_gross = (this.videos[i].packet_price_net * 1.23).toFixed(2);
        }
        if (this.videos[i].selected) {
          this.total_price_net += parseFloat(this.videos[i].packet_price_net);
          this.total_price_gross += parseFloat(this.videos[i].packet_price_gross);
        }
      }
      this.total_price_net = this.total_price_net.toFixed(2);
      this.total_price_gross = this.total_price_gross.toFixed(2);
    },
    selectPacket(video) {
      if (video.selected) {
        this.videos_selected.push(video);
      } else {
        for(var i in this.videos_selected) {
          if (this.videos_selected[i].id == video.id) {
            this.videos_selected.splice(i, 1);
          }
        }
      }
      this.countPrice(0);
      this.$forceUpdate();
    },
    swapUP(id) {
      for(var i in this.videos_selected) {
        if (this.videos_selected[i].id == id) {
          let temp = this.videos_selected[i];
          this.videos_selected[i] = this.videos_selected[i - 1];
          this.videos_selected[i - 1] = temp;
        }
      }
      this.$forceUpdate();
    },
    swapDown(id) {
      for(var i in this.videos_selected) {
        if (this.videos_selected[i].id == id) {
          let temp = this.videos_selected[i];
          this.videos_selected[i] = this.videos_selected[parseInt(i) + 1];
          this.videos_selected[parseInt(i) + 1] = temp;
          break;
        }
      }
      this.$forceUpdate();
    }
  },
}

</script>
